import styled from "styled-components";
import { Body } from "../../components/text";
import { Box } from "rebass/styled-components";
import { Page } from "../../MVVM/Components/Wrappers";

const StyledContainer = styled(Box)`
  margin: 5rem auto;
  max-width: 950px;
  word-break: break-word;
`;

const StyledBody = styled(Body)`
  line-height: 1.444;
  font-size: 1.125rem;
  text-align: left;
`;

const StyledTimeStamp = styled(Body)`
  margin-bottom: 3rem;
`;

const StyledHeader = styled(StyledBody)`
  margin-bottom: 1rem;
`;

const StyledListItem = styled.li`
  margin-bottom: 1rem;
`;

const MasterServicesAgreement = () => {
  return (
    <Page>
      <StyledContainer>
        <StyledTimeStamp>Last updated on December 2, 2024</StyledTimeStamp>
        <StyledHeader>
          <strong>Allstar Gaming, Inc. Standard Terms and Conditions</strong>
        </StyledHeader>
        <StyledBody>
          These Standard Terms and Conditions ("<strong>Standard Terms</strong>
          ") are incorporated by reference into each order form (an “Order
          Form”) and Statement of Work (a “SOW”) executed by Allstar Gaming,
          Inc. (“Allstar”) and Order Form Client (“Client”). The Standard Terms,
          any Order Form, any SOW, and any Appendices or Exhibits attached
          thereto are collectively referred to herein as the "
          <strong>Agreement</strong>."
        </StyledBody>
        <StyledBody>
          <ol>
            <StyledListItem>
              <strong>Services.</strong> Allstar hereby grants Client a limited,
              non-transferable, non-exclusive, revocable right and license to
              obtain access to the services identified on the applicable Order
              Form (<strong>“Services”</strong>) during the term of the Order
              Form on the terms set forth in the Agreement, subject to any
              limitations specified in the Order Form (
              <strong>“Limitations”</strong>). The Services may include any
              tags, scripts, or code (such as html or javascript code) provided
              to Client by Allstar hereunder for use in certain websites, apps,
              email campaigns or other online technology of Client, as well as
              the proprietary software platform and any other infrastructure
              including without limitation any API or other web-based mechanism)
              through which Allstar delivers the Services.{" "}
            </StyledListItem>
            <StyledListItem>
              <strong>Affiliates.</strong> Any Client Affiliate may enter into
              an Order Form with Allstar under these Standard Terms. In such
              event, (i) Client enters into these Standard Terms on behalf of
              such Client Affiliate, (ii) such Client Affiliate shall comply
              with these Standard Terms and such Client Affiliate’s Order Form,
              and (iii) Client shall be fully responsible for such Client
              Affiliate’s actions and omissions in connection with these
              Standard Terms and the Client Affiliate’s Order Form, including
              payment, liability for breach of contract and indemnification. As
              used herein, <strong>“Client Affiliate”</strong> means any entity
              that Client controls or is under common control with Client.
            </StyledListItem>
            <StyledListItem>
              <strong>Ownership and Proprietary Rights.</strong> As between the
              parties, (a) Client owns all right, title and interest (including
              any intellectual property rights) in any trademarks or other
              content provided by Client in connection with the Services and (b)
              Allstar owns all right, title and interest (including any
              intellectual property rights) in the Services, inclusive of any
              infrastructure, know-how, source code, algorithms,
              machine-learning methodology and data used to provide the
              Services. All rights not expressly granted to Client are reserved
              by Allstar.
            </StyledListItem>
            <StyledListItem>
              <strong>Payment.</strong> All fees for the Services (
              <strong>“Fees”</strong>) shall be set forth in the Order Form or
              SOW and (i) are quoted and payable in the currency set forth in
              the applicable Order Form, (ii) are non-refundable and
              non-cancellable (in whole or in part), and (iii) are based on the
              Services and Limitations specified in the applicable Order Form.
              All Fees shall be due and payable in advance upon execution of the
              Order Form and at commencement of any renewal term.
              Notwithstanding the foregoing and unless otherwise specified in
              the Order Form or SOW, Fees for additional Services or for usage
              exceeding any usage Limitations shall be billed monthly in
              arrears. Any payment not received from Client by the due date may
              accrue, at Allstar's discretion, late charges at the rate of one
              and a half percent (1.5%) of the outstanding balance per month, or
              at the maximum rate permitted by law, whichever is lower, from the
              date such payment was due until the date paid. Allstar also
              reserves the right to charge Client other reasonable costs of
              collection. If Client's account is 30 days or more overdue, in
              addition to any of its other rights or remedies, Allstar reserves
              the right to suspend the Services, without liability to Allstar,
              until such amounts are paid in full.
            </StyledListItem>
            <StyledListItem>
              <strong>Taxes.</strong> Fees are exclusive of all local, state,
              federal and foreign taxes, levies, or duties of any nature (
              <strong>“Taxes”</strong>), and Client is responsible for payment
              of all Taxes, excluding only taxes based on Allstar’s income.
              When, as required by law, Client withholds any Taxes from amounts
              payable to Allstar, Client will increase the amounts payable such
              that the net amount paid to Allstar equals the amount calculated
              in accordance with this Agreement. If Allstar has the legal
              obligation to pay or collect Taxes for which Client is responsible
              pursuant to this Section, the appropriate amount shall be invoiced
              to and paid by Client unless Client provides Allstar with evidence
              of a valid tax exemption issued by the appropriate taxing
              authority.
            </StyledListItem>
            <StyledListItem>
              <strong>Communications.</strong> In using the Services, Client
              agrees to abide by all applicable laws, rules, regulations and
              other legal requirements (<strong>“Laws”</strong>), including laws
              governing online activities, reading or writing of cookies or
              other information on an end-user’s device, privacy, email
              marketing and anti-spam laws, as well as any requirements imposed
              by third parties whose products or services Client uses in
              connection with the Services (such as terms of use imposed by a
              third-party platform through which Client sends communications
              that are tailored by the Services). In these Standard Terms, the
              term <strong>“Communication”</strong> means any email message, web
              page, advertisement or other communication that is sent,
              displayed, targeted, created or customized through use of the
              Services. Client shall be responsible for the content of all
              Communications, including obtaining all necessary licenses,
              permissions and consents to enable all material comprising Service
              Data to be made available to Allstar for use in providing the
              Services. Client will ensure that Communications are not, and will
              not give a reasonable observer the impression that Communications
              are, targeted or customized on the basis of Sensitive Personal
              Data (as defined in Section 8).
            </StyledListItem>
            <StyledListItem>
              <strong>Prohibited Products.</strong> Client Products, and the
              Communications promoting Client Products, shall not contain,
              consist of, promote or offer: (i) tobacco products, (ii) bombs,
              grenades, guns or other weapons or instructions on how to assemble
              or otherwise make them, (iii) pornography or illicitly
              pornographic sexual products, including magazines, video, and
              software; escort services; or adult "swinger" promotions, (iv)
              odds making and betting/gambling services that are illegal or
              unlicensed in the jurisdiction in which Client is located or where
              Client Products and Communications are sent from, sent to, or
              offered in, (v) goods; drugs; drug contraband; or pirated computer
              programs that are illegal in the jurisdiction in which Client is
              located or where Client Products and Communications are sent from,
              sent to, or offered in, (vi) products or materials that exploit
              children under 18 years of age, including those that post or
              disclose any personally identifying information or private
              information about children without their consent (or their
              parents' consent in the case of a minor), (vii) products or
              materials frequently associated with unsolicited commercial email,
              a.k.a. spam, such as online and direct pharmaceutical sales,
              including health and sexual well-being products, work at home
              businesses, credit or finance management (including credit repair
              and debt relief offerings, stock and trading tips, and mortgage
              finance offers), or DJ/nightclub and event/club promotions/party
              lists, (viii) products or material that are grossly offensive,
              including blatant expressions of bigotry, prejudice, racism,
              hatred, or excessive profanity or post any obscene, lewd,
              lascivious, filthy, excessively violent, harassing, or otherwise
              objectionable content, (ix) products or materials that introduce
              viruses, worms, harmful code and/or Trojan horses on the Internet,
              (x) products or materials that promote, solicit, or participate in
              pyramid schemes or multi-level channel and/or network marketing
              (MLM) businesses, including personal work-at-home offers promoting
              "get rich quick," "build your wealth" or "financial independence"
              offerings, (xi) products or materials that engage in any libelous,
              defamatory, scandalous, threatening, or harassing activity,
              including those that post any content that advocates, promotes, or
              otherwise encourages violence against any governments,
              organizations, groups, or individuals or which provide
              instruction, information or assistance in causing or carrying out
              such violence, (xii) products or materials that market or are
              marketed to third-party voter registration lists, (xiii) products
              or materials that contain or provide content, including images, of
              authors, artists, photographers, or others without the express
              written consent of the content owner or (ix) any other Products
              which may not be advertised under applicable law (collectively,{" "}
              <strong>“Prohibited Products”</strong>).
            </StyledListItem>
            <StyledListItem>
              <strong>Term and Termination.</strong> The term of each Order Form
              is set forth in the applicable Order Form. The Agreement will
              remain in effect for so long as any Order Form is in effect.
              Either party may terminate any Order Form: (i) upon thirty (30)
              days’ written notice of a material breach of such Order Form or
              these Standard Terms to the other party, provided such breach
              remains uncured at the expiration of the notice period, if such
              breach is capable of being cured; or (ii) if the other party
              becomes the subject of a petition in bankruptcy or any proceeding
              relating to insolvency, receivership, liquidation or assignment
              for the benefit of creditors. The terms and conditions of Sections
              3-7, 9-14, and this sentence shall survive termination of the
              Agreement.
            </StyledListItem>
            <StyledListItem>
              <strong>Confidentiality.</strong> Neither party shall (a) have any
              right or interest in or to the Confidential Information of the
              other party or (b) use any Confidential Information of the other
              party except as permitted by the Agreement. Each party agrees that
              it will take reasonable steps, at least substantially equivalent
              to the steps it takes to protect its own proprietary information
              of similar nature to prevent the disclosure of the other party’s
              Confidential Information other than to its employees, affiliates,
              subsidiaries, sub-processors or other agents who must have access
              to such Confidential Information for such party to perform its
              obligations or exercise its rights hereunder, who each will be
              subject to confidentiality obligations no less strict than those
              set forth in this Section.{" "}
              <strong>“Confidential Information”</strong> means the material
              terms of the Agreement, and any information relating to or
              disclosed in the course of the Agreement that is, or should be
              reasonably understood to be, confidential or proprietary to the
              disclosing party. Confidential Information will not include
              information (i) now or hereafter, through no unauthorized act or
              failure to act on the receiving party’s part, be in the public
              domain; (ii) known to the receiving party without an obligation of
              confidentiality effective at the time the receiving party received
              the same from the disclosing party; (iii) hereafter furnished to
              the receiving party by a third party as a matter of right and
              without restriction on disclosure; or (iv) independently developed
              by the receiving party, as evidenced by written records. Neither
              party may disclose the terms of the Agreement or make any
              announcements regarding the nature of the relationship between the
              parties without the other party’s prior written approval except as
              set forth herein. Nothing in the Agreement shall prevent a party
              from disclosing Confidential Information of the disclosing party
              to the extent the receiving party is legally compelled to do so by
              any governmental investigative or judicial agency pursuant to
              proceedings over which such agency has jurisdiction; provided,
              however, that prior to any such disclosure, the receiving party
              shall (a) assert the confidential nature of the information to the
              agency; (b) immediately notify the disclosing party in writing of
              the agency’s order or request to disclose, to the extent
              permitted; and (c) at the disclosing party’s expense, cooperate
              fully with the disclosing party in protecting against any such
              disclosure and/or obtaining a protective order narrowing the scope
              of the compelled disclosure and protecting its confidentiality. To
              the extent Client tests the Services for an evaluation period, the
              results or evaluation of such testing or monitoring shall be
              deemed the Confidential Information of Allstar.
            </StyledListItem>
            <StyledListItem>
              <strong>Limitation of Liability.</strong> TO THE MAXIMUM EXTENT
              PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES AND UNDER NO
              LEGAL THEORY, WHETHER TORT, CONTRACT, OR OTHERWISE, SHALL ONE
              PARTY BE LIABLE TO THE OTHER OR ANY OTHER PERSON FOR ANY INDIRECT,
              SPECIAL, PUNITIVE, INCIDENTAL, COVER, RELIANCE OR CONSEQUENTIAL
              DAMAGES, INCLUDING LOST REVENUES, AND LOSS OF GOODWILL, BUSINESS
              OR DATA, EVEN IF SUCH PARTY SHALL HAVE BEEN INFORMED OF THE
              POSSIBILITY OF SUCH DAMAGES, AND (ii) THE MAXIMUM AGGREGATE
              LIABILITY OF ONE PARTY TO THE OTHER ARISING IN CONNECTION WITH THE
              AGREEMENT SHALL BE LIMITED TO THE FEES CLIENT PAID UNDER THE ORDER
              FORM THAT SERVES AS THE BASIS FOR THE CLAIM IN THE TWELVE (12)
              MONTHS PRIOR TO THE ACCRUAL OF THE APPLICABLE CLAIM. THE
              LIMITATIONS OF THIS SECTION SHALL NOT BE CONSTRUED TO REDUCE
              AMOUNTS PAYABLE BY CLIENT TO ALLSTAR HEREUNDER.
            </StyledListItem>
            <StyledListItem>
              <strong>Disclaimer.</strong> EXCEPT AS MAY OTHERWISE BE EXPRESSLY
              SET FORTH IN THE ORDER FORM, (A) THE SERVICES ARE PROVIDED ON AN
              “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT, AND ALLSTAR DISCLAIMS,
              ALL WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING,
              WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT, AND ANY WARRANTIES
              THAT MAY ARISE FROM COURSE OF DEALING, COURSE OF PERFORMANCE OR
              USAGE OF TRADE, AND (B) ALLSTAR DOES NOT WARRANT THAT CLIENT’S
              ACCESS TO THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE. NO
              ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY ALLSTAR, ITS AGENTS
              OR EMPLOYEES WILL CREATE A WARRANTY AND CLIENT ASSUMES ALL
              RESPONSIBILITY AND RISK FOR ITS RELIANCE THEREON AND ITS USE OF
              THE SERVICES.
            </StyledListItem>
            <StyledListItem>
              <strong>Assignment.</strong> Neither party may assign or transfer
              any of its rights hereunder without the prior written consent of
              the other party and any attempt to do so is void; provided,
              however, that either party may assign the Agreement in the event
              of a merger, reorganization, purchase of all or substantially all
              of its assets to which the Agreement relates or other change of
              control.
            </StyledListItem>
            <StyledListItem>
              <strong>Miscellaneous.</strong> If there is any inconsistency
              between the Order Form or SOW and these Standard Terms, the Order
              Form or SOW, as applicable, shall govern. The Agreement: (i) will
              be governed by and construed in accordance with the laws of the
              State of New York, without giving effect to principles of
              conflicts of law; and (ii) will not be governed by the United
              Nations Convention of Contracts for the International Sale of
              Goods. The exclusive venue for any dispute relating to the
              Agreement shall be New York County, New York, and Client hereby
              waives any jurisdictional, venue or convenient forum objections
              thereto. CLIENT EXPRESSLY WAIVES ANY RIGHT TO A JURY TRIAL, TO
              JOIN OR CONSOLIDATE CLAIMS BY OR AGAINST OTHER CLIENTS, OR TO
              PURSUE OR PARTICIPATE IN ANY CLAIM AS A REPRESENTATIVE ACTION OR
              CLASS ACTION OR IN A PRIVATE ATTORNEY GENERAL CAPACITY. Prior to
              initiating any legal action, the initiating party shall give the
              other party at least 60 days written notice of its intent to file
              an action. Allstar will provide such notice by e-mail to Client's
              e-mail address on file with Allstar, and Client must provide such
              notice by e-mail to nick@allstar.gg. During such notice period,
              the parties will endeavor to settle amicably by mutual discussions
              any disputes, differences, or claims whatsoever related to the
              Agreement. Failing such amicable settlement and expiration of the
              notice period, any controversy, claim, or dispute arising under or
              relating to the Agreement shall finally be settled in a court of
              competent jurisdiction as set forth herein. Regardless of any
              statute or law to the contrary, any claim or cause of action
              arising out of or related to the Services or the Agreement must be
              filed within one (1) year after such claim or cause of action
              arose or be forever barred. The relationship of the parties under
              the Agreement is that of independent contractors, and the
              Agreement will not be construed to imply that either party is the
              agent of the other. The Agreement is not exclusive to either
              party. The Agreement may be amended only in writing, signed and
              executed by a duly authorized representative of each party. Any
              notices under the Agreement must be sent to the addresses set
              forth in the Order Form (as may be modified by a party upon
              written notice), by facsimile, nationally recognized express
              delivery service or email to the email address on the Order Form,
              and deemed given upon receipt. The Agreement constitutes the
              complete and entire expression of the agreement between the
              parties, and supersedes any and all other proposals, both oral and
              written, representations, warranties and agreements, whether
              written or oral, with respect to the subject matter hereof. Client
              expressly agrees that any varying or additional terms contained in
              any purchase order or any other document or notification issued by
              Client in relation to the Services shall be of no effect and may
              be accepted for administrative convenience only. The waiver of any
              breach or default of the Agreement will not constitute a waiver of
              any subsequent breach or default, and will not act to amend or
              negate the rights of the waiving party. If any provision contained
              in the Agreement is determined to be invalid, illegal or
              unenforceable in any respect under any applicable law, then such
              provision will be severed and replaced with a new provision that
              most closely reflects the original intention of the parties, and
              the remaining provisions of the Agreement will remain unaffected.
              Headings used herein are for reference purposes only, not for
              interpretation hereof. Neither party will have any liability for
              any failure or delay resulting from any governmental action, fire,
              flood, insurrection, earthquake, power failure, hackers, riot,
              explosion, embargo, strikes whether legal or illegal, labor or
              material shortage, transportation interruption of any kind, work
              slowdown or any other condition beyond the control of such party.
            </StyledListItem>
            <StyledListItem>
              <strong>Publicity.</strong> Client gives Allstar permission to use
              Client logo on Allstar’s website and in promotional materials.
              Further, Client gives Allstar permission to create a case study on
              the performance of the Services or on a segment of Client’s end
              users (the <strong>“Case Study”</strong>), and Client agrees to
              participate in the Case Study. If Client is satisfied with the
              Service, Client also agrees to participate in speaking
              opportunities, including conferences and webinars alongside
              Allstar.
            </StyledListItem>
          </ol>
        </StyledBody>
      </StyledContainer>
    </Page>
  );
};

export default MasterServicesAgreement;
